import React, { useEffect, useState } from "react";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { OrganizationCoachesSectionComponent } from "./OrganizationCoachesSectionComponent";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

export const OrganizationCoachesPreviewSectionComponent = ({
  activeUser,
  organizationActiveUsers,
  isFrom = "list",
  query,
}) => {
  const coach = !!query.organizationCoach
    ? organizationActiveUsers.find(
        (obj) => obj._id.toString() === query.organizationCoach.toString()
      )
    : activeUser;
  const [showModal, setShowModal] = useState(false);
  const [user, setUser] = useState(coach);

  useEffect(() => {
    const updatedCoach = !!query.organizationCoach
      ? organizationActiveUsers.find(
          (obj) => obj._id.toString() === query.organizationCoach.toString()
        )
      : activeUser;

    if (updatedCoach) {
      setUser(updatedCoach);
    }
  }, [query.organizationCoach]);

  const toggleCoachModal = () => {
    setShowModal(!showModal);
  };
  const selectOrganizationCoach = (e, coach) => {
    e.stopPropagation();
    e.preventDefault();
    setUser(coach);
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        organizationCoach: coach._id,
        filterGroup: "",
      },
    });
  };
  return (
    <details role="list" open className="dropdown-img">
      <summary
        onClick={(e) => {
          e.preventDefault();
          setShowModal(!showModal);
        }}
      >
        <img src={getAvatarUrl(user)} alt="avatar" />
        <p>{user.name}</p>
        <SvgIcon
          src={showModal ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"}
        />
      </summary>

      <OrganizationCoachesSectionComponent
        isFrom={isFrom}
        onToggleModal={toggleCoachModal}
        activeUser={activeUser}
        onSelectOrganizationCoach={selectOrganizationCoach}
        users={organizationActiveUsers}
        showModal={showModal}
      />
    </details>
  );
};
